import icon1 from './assets/01.jsx';
import icon2 from './assets/02.jsx';
import icon3 from './assets/03.jsx';
import icon4 from './assets/04.jsx';

export const AffilatesContent = [
  {
    icon: icon1,
    title: 'Access To Exclusive Offers',
    text: 'At Vy Media Group we work directly with advertisers and hand select offers to ensure the highest payouts and strongest conversions.',
  },
  {
    icon: icon2,
    title: 'Real Time Stats & Analytics',
    text: 'VMG utilizes enterprise level tracking to provide 100% accurate real time statistics with zero down time.',
  },
  {
    icon: icon3,
    title: 'You’ll Be Paid On Time. Period.',
    text: 'VMG makes it a top priority to provide payments on time and we’ve never missed a single payment ever.',
  },
  {
    icon: icon4,
    title: 'We’re Here To Help. 24/7',
    text: 'We keep an open line of communication with our Affiliates to ensure all questions and concerns are answered promptly.',
  },
];
